<template>
  <div class="design-cockpit-step1">
    <OringAssistantStepCards
      :cards="cards"
      :hide-info-icon="true"
      :key="`${oringDesignCockpitIsRadial}-${oringDesignCockpitGrooveInShaft}-${oringDesignCockpitOnShaft}`"
    />
  </div>
</template>

<script setup lang="ts">
import OringAssistantStepCards from '../OringAssistantStepCards.vue'
import useI18nExtended from '~/composables/usei18nExtended'
import {useORingCalculatorStore} from '~/store/oring-calculator'

const i18n = useI18nExtended()

const {
  oringDesignCockpitIsRadial,
  oringDesignCockpitGrooveInShaft,
  oringDesignCockpitOnShaft
} = storeToRefs(useORingCalculatorStore())

const cards = computed(() => {
  let cardsReturn = []
  cardsReturn.push({
    title: i18n.tv('Frontend.Title.RingCompression', 'ORingConfiguratorImport'),
    description: null,
    model: oringDesignCockpitIsRadial,
    options: [
      {value: true, label: i18n.tv('Frontend.Application.Radial', 'ORingConfiguratorImport'), imgUrl: '/img/oring/cockpit_seal_compression_radial.png'},
      {value: false, label: i18n.tv('Frontend.Application.Axial', 'ORingConfiguratorImport'), imgUrl: '/img/oring/cockpit_seal_compression_axial.png'}
    ]
  })

  if (oringDesignCockpitIsRadial.value) {
    cardsReturn.push({
      title: i18n.tv('Frontend.Report.GroovePosition', 'ORingConfiguratorImport'),
      description: null,
      model: oringDesignCockpitGrooveInShaft,
      options: [
        {value: true, label: i18n.tv('Frontend.Application.GrooveInShaft', 'ORingConfiguratorImport'), imgUrl: '/img/oring/cockpit_groove_pos_inshaft.png'},
        {value: false, label: i18n.tv('Frontend.Application.GrooveInBore', 'ORingConfiguratorImport'), imgUrl: '/img/oring/cockpit_groove_pos_inbore.png'}
      ]
    })

    cardsReturn.push({
      title: i18n.tv('Frontend.Title.RingMounting', 'ORingConfiguratorImport'),
      description: null,
      model: oringDesignCockpitOnShaft,
      options: [
        {value: true, label: i18n.tv('Frontend.Application.MountingOnShaft', 'ORingConfiguratorImport'), imgUrl: '/img/oring/cockpit_seal_compression_radial.png'},
        {value: false, label: i18n.tv('Frontend.Application.MountingInBore', 'ORingConfiguratorImport'), imgUrl: '/img/oring/cockpit_ring_mounting_inbore.png', disabled: oringDesignCockpitGrooveInShaft.value}
      ]
    })
  }

  return cardsReturn
})

watch(oringDesignCockpitGrooveInShaft, (newVal) => {
  oringDesignCockpitOnShaft.value = newVal
})

function validate() {
  return true
}
defineExpose({validate})
</script>

<style lang="scss">
.design-cockpit-step1 {
  .step1-headline {
    margin-bottom: 1.5rem;
    margin-top: 2.5rem;
  }

  .step1-cards-row {
    display: flex;
    gap: 1.5rem;
    flex-wrap: wrap;
  }
}
</style>
